const component = {
  template: `
    <div class="gbCopyright">
      &copy; greenback {{$ctrl.date}}
    </div>
  `,
  bindings: {
    id: '@'
  },
  controller() {
    this.$onInit = () => {
      this.date = new Date().getFullYear();;
    };
  }
};

export default component;



// WEBPACK FOOTER //
// ./js/containers/causePortal/components/gbCopyright/index.js